import {ApiService} from "./api.service";
import {AxiosResponse} from "axios";
import {Author} from "../model/interface/author";

export class WhitelistService {
    public static async getWhitelist(projectId: number) {
        const url:string = ApiService.getInstance().getWhitelistURL(projectId);
        const result: AxiosResponse<Author[]> | false = await ApiService.getInstance().get(url);
        if(result) {
            return <Author[]> result.data;
        } else {
            return false;
        }
    }
    public static async addAuthorToWhitelist(projectId: number, author: Author) {
        const url:string = ApiService.getInstance().getWhitelistAddURL(projectId);
        const result: AxiosResponse<Author> | false = await ApiService.getInstance().post(url, author);
        if(result) {
            return <Author> result.data;
        } else {
            return false;
        }
    }
    public static async addAuthorMultiToWhitelist(projectId: number, authors: Author[]) {
        const url:string = ApiService.getInstance().getWhitelistAddMultiURL(projectId);
        const result: AxiosResponse<Author[]> | false = await ApiService.getInstance().post(url, authors);
        if(result) {
            return <Author[]> result.data;
        } else {
            return false;
        }
    }
    public static async removeAuthorFromWhitelist(projectId: number, author: Author) {
        const url:string = ApiService.getInstance().getWhitelistDeleteURL(projectId, author.id);
        const result: AxiosResponse<number> | false = await ApiService.getInstance().delete(url);
        if(result) {
            return <number> result.data;
        } else {
            return false;
        }
    }
    public static async dropWhitelist(projectId: number) {
        const url:string = ApiService.getInstance().getWhitelistDropURL(projectId);
        const result: AxiosResponse<number> | false = await ApiService.getInstance().delete(url);
        if(result) {
            return <number> result.data;
        } else {
            return false;
        }
    }
}